<script lang="ts">import { browser } from "$app/environment";
import { cfgToThemeCdnPath } from "@infinitro/config";
const prodHosts = [
	"rocketbet.com",
	"www.rocketbet.com",
	"prod-rocketbet.previewenv.net"
];
const showSeal = browser && prodHosts.includes(window.location.hostname);
</script>

<div class="rocket-seals">
	{#if showSeal}
		<iframe
			title="Seal"
			src="/seal-rocket.htm"
			style="height: 50px; width: 50px; border: none; display: block;"
		></iframe>
	{/if}
	<div id="trust-seal-container">
		<a
			id="trust-seal-container-a"
			href="https://gamecheck.tech/seal-scan/fd1c837d-2c44-459e-a570-5ec4b4e61f1f?referrer=rocketbet.com"
			target="_blank"
		>
			<img
				src={cfgToThemeCdnPath('/footer/rocketbet-seal.png')}
				alt="Gamecheck Trust SEAL"
				width="217"
				height="64"
			/>
		</a>
	</div>
</div>

<style>
	.rocket-seals {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: center;
		gap: 12px;
	}

	#trust-seal-container-a {
		display: inline-block;
		transition: transform 0.2s ease-in-out;
	}

	#trust-seal-container-a:hover {
		transform: scale(1.1);
	}

	#trust-seal-container img {
		display: block;
		width: 217px;
		height: 64px;
		min-width: 217px;
		min-height: 64px;
	}
</style>
